import { translate } from "app/filters/i18nFilter";
import { DashboardTrackerTooltipContent } from "../AssetsTooltipContent/DashboardTooltipContent";
import { KeywordsListTooltipContent } from "../AssetsTooltipContent/KeywordsListTooltipContent";
import { navigateToDashboardsTemplatesGallery } from "../customAssetsUtils";
import type { IAssetCreationItem } from "../types";
import { allTrackers } from "app/services/track/track";

export const getAssetCreationItems = (onModalOpen: () => void): IAssetCreationItem[] => [
    {
        iconName: "keyword-group",
        onClick: () => {
            allTrackers.dispatchTrackEvent("Button", "click", "My Assets/create item/keywordlist selected");
            onModalOpen();
        },
        text: translate("digitalmarketing.homepage.custom_assets.button.dropdown.keywordsList"),
        tooltipContent: <KeywordsListTooltipContent />,
    },
    {
        iconName: "dashboard",
        onClick: () => {
            allTrackers.dispatchTrackEvent("Button", "click", "My Assets/create item/dashboard selected");
            navigateToDashboardsTemplatesGallery();
        },
        text: translate("digitalmarketing.homepage.custom_assets.button.dropdown.dashboard"),
        tooltipContent: <DashboardTrackerTooltipContent />,
    },
];
